export function isElement(node: ChildNode): node is Element {
  return 'localName' in node;
}
